import { useMediaQuery } from 'usehooks-ts';

import MEDIA_QUERY from 'constants/mediaQuery';

function useScreenQuery() {
  const isScreenMD = useMediaQuery(MEDIA_QUERY.MD);
  const isScreenXL = useMediaQuery(MEDIA_QUERY.XL);
  const isScreenSM = useMediaQuery(MEDIA_QUERY.SM);

  return {
    isScreenMD,
    isScreenXL,
    isScreenSM,
  };
}

export default useScreenQuery;
